export default __webpack_public_path__ + "static/media/wallet load.ebcef988.svg";